import {
  Oem,
  Nameplate
} from "@common-core/coat-operational-hierarchy-appsync-model";
import {toOem} from "./toOem";

export const toOems = (nameplates: Nameplate[]): Oem[] => nameplates.map(toOem);
